import { Injectable } from '@angular/core';
import { ApiService } from '../API/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {
   
  constructor(public apiService: ApiService) { }

  addCompany(body: any): Observable<any> {
    return this.apiService.post('User/createCompany', body)
  }

  bulkInactivate(body: any): Observable<any> {
    return this.apiService.post('company/bulkInactivate', body)
  }

  bulkActivate(body: any): Observable<any> {
    return this.apiService.post('company/bulkActivate', body)
  }

  bulkDelete(body: any): Observable<any> {
    return this.apiService.post('company/bulkDelete', body)
  }
   getAllCompanies(body: any): Observable<any> {
    const active = body && body.payload ? body.payload.active : undefined;
    const path = (active === undefined || active === null)
      ? 'Company/getAllCompanies'
      : 'Company/getAllCompanies?inactive=' + active;
    return this.apiService.get(path)
  }

  downloadFile(data, filename='data') {
    let csvData = this.ConvertToCSV(data, ['Company Internal Id','CompanyName','Address','Contact Person Name',
  'Phone Number','EmailId','License Status','License Expiry Date']);
    console.log(csvData)
    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
        dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
} 

  ConvertToCSV(objArray, headerList) {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row = 'S.No,';

    for (let index in headerList) {
        row += headerList[index] + ',';
    }
    row = row.slice(0, -1);
    str += row + '\r\n';
    for (let i = 0; i < array.length; i++) {
        let line = (i+1)+'';
        for (let index in headerList) {
           let head = headerList[index];

            line += ',' + array[i][head];
        }
        str += line + '\r\n';
    }
    return str;
}

  
}
